(function () {
  'use strict';

  var STORAGE_KEY = 'fh_wishlist_v1';
  var FAVORITES_URL = '/pages/favoritos';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: handles } }));
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    var added;
    if (idx !== -1) {
      list.splice(idx, 1);
      added = false;
    } else {
      list.push(handle);
      added = true;
    }
    setWishlist(list);
    return added;
  }

  function remove(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) return;
    list.splice(idx, 1);
    setWishlist(list);
  }

  window.FinhiloWishlist = {
    STORAGE_KEY: STORAGE_KEY,
    FAVORITES_URL: FAVORITES_URL,
    getWishlist: getWishlist,
    isSaved: isSaved,
    toggle: toggle,
    remove: remove,
  };

  function handleFromUrl(url) {
    if (!url) return null;
    var match = url.split('?')[0].match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function escapeHtml(str) {
    if (str === undefined || str === null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function heartSvg() {
    return (
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="wishlist-heart__icon" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" fill="none"/>' +
      '</svg>'
    );
  }

  /* ---- Toast: single instance, reused and its timer reset on repeat saves ---- */
  var toastTimeout = null;

  function ensureToastEl() {
    var el = document.querySelector('[data-wishlist-toast]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'wishlist-toast';
    el.setAttribute('data-wishlist-toast', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  function showToast(kind) {
    var el = ensureToastEl();
    clearTimeout(toastTimeout);
    if (kind === 'added') {
      el.innerHTML =
        '<span class="wishlist-toast__text">Guardado en favoritos</span>' +
        '<a href="' + FAVORITES_URL + '" class="wishlist-toast__link">Ver favoritos</a>';
    } else {
      el.innerHTML = '<span class="wishlist-toast__text">Eliminado de favoritos</span>';
    }
    el.classList.add('is-visible');
    toastTimeout = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 3500);
  }

  /* ---- Heart button: shared build + wire logic for cards and product page ---- */
  function buildHeartButton(handle, context) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-heart wishlist-heart--' + context;
    btn.setAttribute('data-wishlist-handle', handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = heartSvg();
    wireHeart(btn, handle);
    return btn;
  }

  function wireHeart(btn, handle) {
    function refresh() {
      var saved = isSaved(handle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = saved ? 'Eliminar de favoritos' : 'Agregar a favoritos';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('data-wishlist-label', label);
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var added = toggle(handle);
      btn.classList.add('wishlist-heart--pulse');
      window.setTimeout(function () {
        btn.classList.remove('wishlist-heart--pulse');
      }, 200);
      refresh();
      showToast(added ? 'added' : 'removed');
    });

    document.addEventListener('wishlist:change', refresh);
    refresh();
  }

  function injectCardHearts(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var cards = scope.querySelectorAll('.card-wrapper.product-card-wrapper:not([data-wishlist-ready])');
    cards.forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link ? handleFromUrl(link.getAttribute('href')) : null;
      if (!handle) return;
      card.setAttribute('data-wishlist-ready', 'true');
      card.style.position = card.style.position || 'relative';
      card.appendChild(buildHeartButton(handle, 'card'));
    });
  }

  function injectProductHeart() {
    var info = document.querySelector('product-info[data-url]:not([data-wishlist-ready])');
    if (!info) return;
    var handle = handleFromUrl(info.getAttribute('data-url'));
    if (!handle) return;
    var container = info.querySelector('.product__info-container');
    if (!container) return;
    info.setAttribute('data-wishlist-ready', 'true');
    var btn = buildHeartButton(handle, 'product');
    var existingToggle = container.querySelector('.compare-toggle');
    if (existingToggle && existingToggle.parentNode === container) {
      existingToggle.insertAdjacentElement('afterend', btn);
    } else {
      container.insertBefore(btn, container.firstChild);
    }
  }

  function initInjection() {
    injectCardHearts(document);
    injectProductHeart();
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            injectCardHearts(node);
          });
        });
        injectProductHeart();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- Header icon: count badge ---- */
  function initHeaderBadge() {
    var badge = document.querySelector('[data-wishlist-count-badge]');
    if (!badge) return;
    function refresh() {
      var count = getWishlist().length;
      if (count > 0) {
        badge.hidden = false;
        badge.textContent = '(' + count + ')';
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }
    document.addEventListener('wishlist:change', refresh);
    refresh();
  }

  /* ---- Favorites page ---- */
  function fetchWishlistProduct(handle, sectionId) {
    var url = '/products/' + handle + '?section_id=' + sectionId;
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-wishlist-json]');
        if (!script) return null;
        try {
          return JSON.parse(script.textContent);
        } catch (e) {
          return null;
        }
      })
      .catch(function () {
        return null;
      });
  }

  function initWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id') || 'wishlist-data';
    var exploreUrl = root.getAttribute('data-explore-url') || '/pages/encuentra-tu-prenda';

    function renderEmpty() {
      root.innerHTML =
        '<div class="wishlist-page__empty">' +
        '<p class="wishlist-page__empty-title">Aún no tienes favoritos.</p>' +
        '<p class="wishlist-page__empty-text">Guarda las prendas que te interesen para encontrarlas fácilmente después.</p>' +
        '<a href="' + exploreUrl + '" class="button">Explorar productos</a>' +
        '</div>';
    }

    function cardMarkup(p) {
      return (
        '<div class="wishlist-card">' +
        '<a href="' + p.url + '" class="wishlist-card__image-wrap">' +
        (p.image ? '<img class="wishlist-card__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="500">' : '') +
        '</a>' +
        buildHeartHtml(p.handle) +
        '<a href="' + p.url + '" class="wishlist-card__title">' + escapeHtml(p.title) + '</a>' +
        '<p class="wishlist-card__price">' + escapeHtml(p.price) + '</p>' +
        '<a href="' + p.url + '" class="wishlist-card__link link">Ver producto</a>' +
        '</div>'
      );
    }

    function buildHeartHtml(handle) {
      return (
        '<button type="button" class="wishlist-heart wishlist-heart--card is-saved" data-wishlist-handle="' +
        escapeHtml(handle) +
        '" data-wishlist-page-remove aria-pressed="true" aria-label="Eliminar de favoritos">' +
        heartSvg() +
        '</button>'
      );
    }

    function bindRemoveButtons() {
      root.querySelectorAll('[data-wishlist-page-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var handle = btn.getAttribute('data-wishlist-handle');
          remove(handle);
          showToast('removed');
        });
      });
    }

    function render() {
      var handles = getWishlist();
      if (!handles.length) {
        renderEmpty();
        return;
      }
      root.innerHTML = '<div class="wishlist-page__loading"><div class="loading__spinner"><svg class="spinner" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
      Promise.all(handles.map(function (h) { return fetchWishlistProduct(h, sectionId); })).then(function (results) {
        var products = results.filter(Boolean);
        if (!products.length) {
          renderEmpty();
          return;
        }
        root.innerHTML = '<div class="wishlist-grid">' + products.map(cardMarkup).join('') + '</div>';
        bindRemoveButtons();
      });
    }

    document.addEventListener('wishlist:change', render);
    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInjection();
    initHeaderBadge();
    initWishlistPage();
  });
})();
